export default __webpack_public_path__ + "static/media/Letters1_01.3a893591.png";